import * as React from "react";
import { Component } from "react";
import { Button, FormControl, FormGroup, Glyphicon, Navbar, Table } from "react-bootstrap";
import { Redirect } from "react-router";
import LoadingStatus from "src/components/common/LoadingStatus";
import "src/css/pages/projects/project/templates/statementtemplatepage.css";
import { TIMEOUT } from "src/global";
import { IDefaultProps } from "src/interfaces";
import fs from "src/services/config/fbConfig";
import { IFieldTemplate, IStatementTemplatePageState } from "./interfaces";

export default class StatementTemplatePage extends Component<
  IDefaultProps,
  IStatementTemplatePageState
> {
  private projectDocument: firebase.firestore.DocumentReference;
  private fieldMappingCollection: firebase.firestore.CollectionReference;
  private unsubscribe: any;

  private statementFields = [
    {
      key: "statementDate",
      value: "Statement Date",
    },
    {
      key: "serviceStartDate",
      value: "Service Start",
    },
    {
      key: "serviceEndDate",
      value: "Service End",
    },
  ];

  public constructor(props: IDefaultProps) {
    super(props);

    this.state = { loading: true, fieldTemplates: [] };

    this.renderNavbar = this.renderNavbar.bind(this);
    this.updateFieldMappings = this.updateFieldMappings.bind(this);
    this.addFieldTemplate = this.addFieldTemplate.bind(this);
    this.searchCriterionChanged = this.searchCriterionChanged.bind(this);
    this.deleteFieldMapping = this.deleteFieldMapping.bind(this);
    this.getFieldsFor = this.getFieldsFor.bind(this);
    this.fieldTypeChanged = this.fieldTypeChanged.bind(this);
    this.fieldChanged = this.fieldChanged.bind(this);
    this.saveFieldTemplates = this.saveFieldTemplates.bind(this);
  }

  public componentWillMount() {
    this.projectDocument = fs.fs.collection("projects").doc(this.props.match.params.id);
    this.fieldMappingCollection = this.projectDocument.collection("fieldTemplates");
    this.unsubscribe = this.fieldMappingCollection
      .orderBy("timestamp")
      .onSnapshot(this.updateFieldMappings);
  }

  public componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, TIMEOUT);
  }

  public componentWillUnmount() {
    this.unsubscribe(this.updateFieldMappings);
  }

  public render() {
    if (!this.props.appService.isAuthenticated()) {
      return <Redirect to="/login" />;
    }

    if (this.state.loading) {
      return <LoadingStatus text="Loading..." />;
    }

    return (
      <div className="container container-fixed-navbar">
        {this.renderNavbar()}
        <p>
          To configure the statement template, follow these steps.
          <ol>
            <li>Add a new row</li>
            <li>Specify a search criterion</li>
            <li>
              Specify the field type - this can be "Statement", "Service Charge" or "Tax and Fee"
            </li>
            <li>Continue adding until you've specified all appropriate mappings.</li>
          </ol>
          <p>
            The order in which you enter your template will be the order in which it is processed.
          </p>
          <p>
            Make sure you do not map the same fields to multiple search criterion. The last mapping
            will "win".
          </p>
        </p>
        <Button
          className="button-bottom-plus-half"
          bsSize="small"
          bsStyle="primary"
          onClick={this.addFieldTemplate}
        >
          Add
        </Button>
        <Button
          className="button-left button-bottom-plus-half"
          bsSize="small"
          bsStyle="success"
          onClick={this.saveFieldTemplates}
        >
          Save
        </Button>
        <Table style={{ border: "1px solid black" }}>
          <colgroup>
            <col width="70%" />
            <col width="15%" />
            <col width="15%" />
          </colgroup>
          <thead>
            <tr>
              <th>Search Criteria</th>
              <th>Field Type</th>
              <th>Field</th>
              <th>
                <Button bsSize="xs" bsStyle="danger" disabled={true}>
                  <Glyphicon glyph="glyphicon glyphicon-remove" />
                </Button>
              </th>
            </tr>
          </thead>
          <tbody>
            {this.state.fieldTemplates &&
              this.state.fieldTemplates.map((template, index, templates) => (
                <tr key={template.id}>
                  <td className="criterion-cell">
                    <FormGroup bsSize="small" controlId="searchCriterion">
                      <FormControl
                        bsSize="small"
                        type="text"
                        // tslint:disable-next-line:jsx-no-lambda
                        onChange={e => this.searchCriterionChanged(e, index, templates)}
                        value={template.searchCriterion}
                      />
                    </FormGroup>
                  </td>
                  <td className="fieldType-cell">
                    <FormGroup controlId="fieldType">
                      <select
                        id="fieldType"
                        value={template.fieldType}
                        // tslint:disable-next-line:jsx-no-lambda
                        onChange={e => {
                          this.fieldTypeChanged(e, index, templates);
                        }}
                      >
                        <option key="unassigned" />
                        <option key="statementField">Statement Field</option>
                        <option key="serviceCharge">Service Charge</option>
                        <option key="taxAndFee">Tax and fee</option>
                      </select>
                    </FormGroup>
                  </td>
                  <td className="field-cell">
                    <FormGroup controlId="field">
                      <select
                        id="field"
                        // tslint:disable-next-line:jsx-no-lambda
                        onChange={e => this.fieldChanged(e, index, templates)}
                        value={template.field}
                      >
                        <option key="serviceStartDate">Service Start Date</option>
                        <option key="serviceEndDate">Service End Date</option>
                        <option key="statementDate">Statement Date</option>
                        <option key="totalAmountDue">Total Amount Due</option>
                        <option key="gridUsage">Grid Usage</option>
                        <option key="solarUsage">Solar Received</option>
                        <option key="solarGenerated">Solar Generated</option>
                        <option key="lastMonthCredit">Last Month's Credit</option>
                      </select>
                    </FormGroup>
                  </td>
                  <td className="actions-cell">
                    <Button
                      bsSize="small"
                      bsStyle="danger"
                      // tslint:disable-next-line:jsx-no-lambda
                      onClick={() => this.deleteFieldMapping(template.id)}
                    >
                      <Glyphicon glyph="glyphicon glyphicon-remove" />
                    </Button>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    );
  }

  private renderNavbar() {
    return (
      <Navbar className="projects-Navbar">
        <Navbar.Header>
          <Navbar.Brand>Statement Template</Navbar.Brand>
        </Navbar.Header>
      </Navbar>
    );
  }

  private updateFieldMappings(querySnapshot: firebase.firestore.QuerySnapshot) {
    const fieldTemplates: IFieldTemplate[] = [];
    querySnapshot.forEach(doc => {
      if (doc.exists) {
        const { timestamp, searchCriterion, fieldType, field } = doc.data() as any;
        fieldTemplates.push({
          id: doc.id,
          timestamp,
          searchCriterion,
          fieldType,
          field,
        });
      }
    });
    this.setState({ fieldTemplates });
  }

  private addFieldTemplate(e: any) {
    e.preventDefault();

    this.fieldMappingCollection.add({
      timestamp: Date.now(),
      searchCriterion: "",
      fieldType: "",
      field: "",
    });
  }

  private searchCriterionChanged(e: any, index: number, fieldTemplates: IFieldTemplate[]) {
    fieldTemplates[index].searchCriterion = e.target.value;
    this.setState({ fieldTemplates });
  }
  private fieldTypeChanged(e: any, index: number, fieldTemplates: IFieldTemplate[]) {
    fieldTemplates[index].fieldType = e.target.value;
    this.setState({ fieldTemplates });
  }
  private fieldChanged(e: any, index: number, fieldTemplates: IFieldTemplate[]) {
    fieldTemplates[index].field = e.target.value;
    this.setState({ fieldTemplates });
  }
  private deleteFieldMapping(id: string) {
    this.fieldMappingCollection.doc(id).delete();
  }
  private getFieldsFor(fieldType: string) {
    if (fieldType === "statementField") {
      const items = [];
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.statementFields.length; i++) {
        items.push(
          <option key={this.statementFields[i].key}>{this.statementFields[i].value}</option>
        );
      }
      return items;
    }
    return <option key="unassigned" />;
  }
  private saveFieldTemplates(e: any) {
    e.preventDefault();
    this.state.fieldTemplates.forEach(template => {
      this.fieldMappingCollection.doc(template.id).update(template);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/project/templates/StatementTemplatePage.tsx